import React from 'react';
import {t} from 'ttag';
import {GridColDef} from '@mui/x-data-grid';
import {Box} from '@mui/material';

export const columns: GridColDef[] = [
  {
    field: 'reference',
    headerName: t`Reference`,
    flex: 2,
    minWidth: 300,
    disableColumnMenu: true,
    sortable: false
  },
  {
    field: 'code',
    headerName: t`Code`,
    flex: 1,
    minWidth: 200,
    sortable: false,
    renderCell: (params) => { return Array.isArray(params.row.code) ? (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        {params.row.code.map((code: string, id: number) => (
          <span key={code + id}>{code}</span>
        ))}
      </div>
    ) : (
      <span>{params.row.code}</span>
    )}
  },
  {
    field: 'unitPrice',
    headerName: t`Unit Price`,
    flex: 1,
    minWidth: 200,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
    cellClassName: (params) => (params.row?.field === 'Total' ? 'bold' : ''),
    renderCell: (params) => {
      if (params.row?.field === 'Total') {
        return (
          <Box display={'flex'} gap={1.5} alignItems={'center'}>
            <span>{t`Total:`}</span>
            <span>{params?.row?.unitPrice}</span>
          </Box>
        );
      }
    }
  }
];
